import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, setToken, removeToken } from '../utils/token';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 prevent premature render
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (token && typeof token === 'string' && token.split('.').length === 3) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUser(decoded);
      } catch (err) {
        console.warn('Invalid token in localStorage');
        removeToken();
        setUser(null);
      }
    }
    setLoading(false); // 👈 done checking
  }, []);

  const login = (user, token) => {
    setToken(token);
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      setUser(decoded);
    } catch (err) {
      console.warn('Token decoding failed');
      setUser(user); // fallback to passed-in user
    }
  };

  const logout = () => {
    removeToken();
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {!loading && children} {/* 👈 don't render children until auth is loaded */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
